import { equals, pipe, prop } from "ramda";

const Navbar = (data) => {
  const getLinkDetails = (id) => data.rels.find(pipe(prop("uuid"), equals(id)));

  const NavItem = (navItem) => {
    const linkDetails = getLinkDetails(navItem.link.id);

    if (linkDetails) {
      return navItem
    }

    if (navItem.items?.length) {
      return {
        ...navItem,
        items: navItem.items.map(NavItem).filter(Boolean)
      };
    }

    return null;
  };

  return {
    ...data.story,
    content: {
      ...data.story.content,
      items: data.story.content.items.map(NavItem).filter(Boolean),
    },
  };
};

export { Navbar };
